export const FETCH_COUNT_DATA_REQUEST = 'FETCH_COUNT_DATA_REQUEST';
export const FETCH_COUNT_DATA_SUCCESS = 'FETCH_COUNT_DATA_SUCCESS';
export const FETCH_COUNT_DATA_FAILURE = 'FETCH_COUNT_DATA_FAILURE';
